import {createContext, useContext, useState} from 'react'
import {useNavigate} from 'react-router-dom'

import {useErrorHandler} from '../../../../../../_metronic/helpers/ErrorHandler'
import * as ReportService from '../../services/ReportService'

const ViewEconomicReportContext = createContext()

export function useViewEconomicReportContext() {
  return useContext(ViewEconomicReportContext)
}

export function ViewEconomicReportProvider({children}) {
  const [loading, setLoading] = useState(true)
  const [report, setReport] = useState(null)
  const [deleteReport, setDeleteReport] = useState(false)
  const {errorHandler} = useErrorHandler()
  const navigate = useNavigate()

  const close = () => {
    setDeleteReport(false)
    navigate('/gis/reports/economic')
  }

  const load = (id) => {
    setLoading(true)
    setReport(null)
    errorHandler(ReportService.getEconomicReport(id)).then((res) => {
      if (res.ok) {
        setReport(res.data)
      } else {
        close()
      }

      setLoading(false)
    })
  }

  const updateName = async (name) => {
    const res = await errorHandler(ReportService.updateEconomicReport(report.id, {name}))
    if (res?.ok) {
      setReport(res.data)
    }
    return res
  }

  const value = {
    close,
    deleteReport,
    loading,
    load,
    report,
    setDeleteReport,
    updateName,
  }

  return (
    <ViewEconomicReportContext.Provider value={value}>
      {children}
    </ViewEconomicReportContext.Provider>
  )
}
